export const membershipListEn = {
  membershipList: {
    info: {
      creditAssuranceOrder: 'Credit Assurance Order',
      liabilityInsurance: 'Liability Insurance',
      promotionalPictures: 'Promotional Pictures',
      promotionalVideos: 'Promotional Videos',
    },
    filter: {
      title: 'Filter',
      reset: 'Reset',
      caseTitle: 'Case Studies',
      case: 'Filter merchants with case studies',
      creditTitle: 'Credit Assurance',
      credit: 'Filter merchants with credit assurance',
      jcvfTitle: 'JC Verified',
      jcvf: 'JC Verified',
      goodServiceTitle: 'Service Highlights',
      goodService: 'Good Service Quality',
      showResult: 'Show Result',
    },
    list: {
      filter: 'Filter',
      noData: 'No Data',
      searchEmpty: 'No results found.',
      membership: 'Membership',
      orders: 'Orders',
      orderAmount: 'Order Amount',
      viewAll: 'View All',
      buyerFlag: 'Gold Buyer',
      sellerFlag: 'Gold Seller',
    },
    serviceScope: {
      title: 'Service Scope',
      advantages: 'Main Business',
      memberShip: 'Membership',
      advantagePort: 'Core Ports',
      seaFreightAdvantageous: 'Sea Freight Routes',
      airFreightAdvantageous: 'Air Freight Routes',
      shippingPartners: 'Shipping Partners',
      airPartners: 'Airline Partners',
      reliableAdvantages: 'Reliable Advantages',
      certificates: 'Certificates',
      serviceFeatures: 'Service Highlights',
    },
    company: {
      profile: 'Profile',
      basicInformation: 'Basic Information',
      location: 'Location',
      address: 'Address',
      establishedDate: 'Establishment time',
      enterpriseSize: 'Enterprise Size',
      website: 'Website',
      all: 'Show All',
      less: 'Show Less',
    },
    contact: {
      getContacts: 'Get Contacts',
    },
    attendedHistory: {
      title: 'Attended History',
      companyEventPhoto: 'Company/Event Photos',
      all: 'Show All',
      less: 'Show Less',
      schedule: 'Schedule',
      history: 'History',
    },
    conferencePerformance: {
      title: 'Conference Performance',
      historyTitle: 'Conference History',
      historyTitleSuffix: 'Global Conferences',
      galleryTitle: 'Company / Event Photos',
      totalOneOnOne: 'Total 1-on-1 Meetings',
      totalOneOnOneDescEn:
        'Verified face-to-face meetings across {count} global conferences',
      totalOneOnOneDescCn: '跨 {count} 场全球会议的真实面对面商务洽谈',
      countriesConnected: 'Countries Connected',
      matchedOpportunities: 'Matched Opportunities',
      marketInterest: 'Market Interest',
      positiveReviews: 'Positive Reviews',
      sinceIntent: 'since Sep 2026',
      sinceReviews: 'since Jun 2025',
      overviewFootnote:
        'Matched Opportunities & Market Interest tracked from the U.S. conference (Sep 8, 2026); Positive Reviews from the Dubai conference (Jun 24, 2025). Metrics before their start date show "/". Company figures aggregate all attendee accounts under this company.',
      ongoing: 'Ongoing',
      upcoming: 'Upcoming',
      oneOnOneShort: '1-on-1 Meetings',
      matchedShort: 'Matched Opportunities',
      interestShort: 'Market Interest',
      reviewsShort: 'Positive Reviews',
      countriesShort: 'Countries Connected',
    },
    store: {
      showPhotToPC:
        'If you need to preview the insurance policy, please go to the PC client to download',
    },
    RiskAlerts: {
      riskAlerts: 'Subscribe',
      cancelAlerted: 'Subscribed',
      success: 'Subscribe Successfully',
      cancel: 'Unsubscribe Successfully',
      fail: 'Subscription Failed',
      repeat: 'Subscribe has been repeated',
      subNotSelf:
        'Subscribing to your own business is not currently supported.',
      riskAlertsReachLimit: 'The company subscription limit has been reached.',
      riskAlertsBecomeMember: `Use the Subscribe function after joining the International Credit Guarantee Membership.`,
      suspend:
        'Member service has been suspended and "Subscribe" cannot be used.',
      suspendConfirm: 'Confirm',
      confirm: 'Confirm',
      sendMessage: 'Send Message',
      sendMessageTo: 'Send message to...?',
      online: 'Online',
      offline: 'Offline',
      customService: 'Customer Service',
    },
  },
}

export const membershipListCn = {
  membershipList: {
    info: {
      creditAssuranceOrder: '信保订单',
      liabilityInsurance: '货代责任险',
      promotionalPictures: '宣传照片',
      promotionalVideos: '宣传视频',
    },
    filter: {
      title: '筛选',
      reset: '重置',
      caseTitle: '合作案例',
      case: '筛选有合作案例的商家',
      creditTitle: '信保订单',
      credit: '筛选有信保订单的商家',
      jcvfTitle: 'JC Verified',
      jcvf: 'JC Verified',
      goodServiceTitle: '服务特色',
      goodService: '服务质量好',
      showResult: '显示结果',
    },
    list: {
      filter: '筛选',
      noData: '没有更多了',
      searchEmpty: '当前搜索无结果',
      membership: '会员身份',
      orders: '订单数',
      orderAmount: '订单金额',
      viewAll: '查看全部',
      buyerFlag: '金牌买家',
      sellerFlag: '金牌卖家',
    },
    serviceScope: {
      title: '服务范围',
      advantages: '业务优势',
      memberShip: '会员类型',
      advantagePort: '优势港口',
      seaFreightAdvantageous: '海运优势',
      airFreightAdvantageous: '空运优势',
      shippingPartners: '合作船司',
      airPartners: '合作航司',
      reliableAdvantages: '可靠优势',
      certificates: '行业证书',
      serviceFeatures: '服务特色',
      // 1. 展示商家的业务优势、优势港口、优势航线、合作承运人。业务优势全部展示，其他仅展示一行，一行展示不下省略...；2. 整体无数据则不展示该模块，对应Title模块下若无数据则Title也不展示；3. 点击后页面上划展示全量的服务范围；
    },
    company: {
      profile: '简介',
      basicInformation: '基础信息',
      location: '所在地',
      address: '地址',
      establishedDate: '成立时间',
      enterpriseSize: '企业规模',
      website: '官网',
      all: '查看全部',
      less: '收起',
    },
    contact: {
      getContacts: '获取联系方式',
    },
    attendedHistory: {
      title: '参会回顾',
      companyEventPhoto: '公司/展会照片',
      all: '查看全部',
      less: '收起',
      schedule: '进行中',
      history: '历史',
    },
    conferencePerformance: {
      title: '会议商机表现',
      historyTitle: '历届会议',
      historyTitleSuffix: '场全球会议',
      galleryTitle: '公司/会议照片',
      totalOneOnOne: '累计 1V1 洽谈',
      totalOneOnOneDescCn: '跨 {count} 场全球会议的真实面对面商务洽谈',
      totalOneOnOneDescEn:
        'Verified face-to-face meetings across {count} global conferences',
      countriesConnected: '连接国家/地区',
      matchedOpportunities: '已匹配商机',
      marketInterest: '市场兴趣度',
      positiveReviews: '收获好评',
      sinceIntent: '2026 年 9 月起',
      sinceReviews: '2025 年 6 月起',
      overviewFootnote:
        '已匹配商机与市场兴趣度自美国会议（2026-09-08）起采集；好评自迪拜会议（2025-06-24）起采集。起始日期前的指标显示「/」。公司数据由旗下全部参会账号聚合而成。',
      ongoing: '进行中',
      upcoming: '未开始',
      oneOnOneShort: '1V1 洽谈',
      matchedShort: '已匹配商机',
      interestShort: '市场兴趣度',
      reviewsShort: '收获好评',
      countriesShort: '连接国家/地区',
    },
    store: {
      showPhotToPC: '如要预览保单，请前往PC客户端下载',
    },
    RiskAlerts: {
      riskAlerts: '订阅',
      cancelAlerted: '订阅中',
      success: '订阅成功',
      cancel: '取消订阅成功',
      fail: '订阅失败',
      repeat: '订阅重复',
      subNotSelf: '暂不支持订阅自己企业',
      riskAlertsReachLimit: '企业订阅达到上限',
      riskAlertsBecomeMember: '加入国际信誉保障会员后，才可使用订阅功能',
      suspend: '会员服务已被暂停，无法使用订阅功能',
      suspendConfirm: '我知道了',
      confirm: '确认',
      sendMessage: '发送消息',
      sendMessageTo: '发消息给...?',
      online: '在线',
      offline: '离线',
      customService: '咨询客服',
    },
  },
}
